import React, { useCallback } from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';
import { useDispatch, useSelector } from 'react-redux';
import { MDialog } from 'common';
import {
  clearDialogCallbacks,
  closeConfirmationDialog,
  getConfirmationDialog,
  getDialogCallbacks,
} from 'store/Confirmationdialogslice';

const GlobalConfirmationDialog = () => {
  const dispatch = useDispatch();
  const {
    header,
    leftButtonActionType,
    leftButtonText,
    message,
    open,
    rightButtonActionType,
    rightButtonText,
    warningList,
  } = useSelector(getConfirmationDialog);

  const handleClose = useCallback(async () => {
    const { cancelAction } = getDialogCallbacks();
    clearDialogCallbacks();
    dispatch(closeConfirmationDialog());
    await cancelAction?.();
  }, [dispatch]);

  const handleConfirm = useCallback(async () => {
    const { confirmAction } = getDialogCallbacks();
    clearDialogCallbacks();
    dispatch(closeConfirmationDialog());
    await confirmAction?.();
  }, [dispatch]);

  const resolveActionByType = useCallback(
    actionType => (actionType === 'confirm' ? handleConfirm : handleClose),
    [handleClose, handleConfirm]
  );

  return (
    <MDialog
      header={header}
      leftButtonAction={resolveActionByType(leftButtonActionType)}
      leftButtonText={leftButtonText}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
        handleClose();
      }}
      open={open}
      rightButtonAction={resolveActionByType(rightButtonActionType)}
      rightButtonText={rightButtonText}
      slotProps={{
        paper: {
          sx: {
            '& .MuiDialogActions-root': {
              alignItems: 'center',
              alignSelf: 'stretch',
              display: 'flex',
              gap: '8px',
              justifyContent: 'flex-end',
              padding: '16px 24px 24px 24px',
            },
            '& .MuiDialogContent-root': {
              alignItems: 'flex-start',
              alignSelf: 'stretch',
              backgroundColor: 'transparent',
              display: 'flex',
              flexDirection: 'column',
              padding: '0 24px',
            },
            '& .MuiDialogTitle-root': {
              alignItems: 'flex-start',
              alignSelf: 'stretch',
              display: 'flex',
              flexDirection: 'column',
              padding: '24px 24px 8px 24px',
            },
          },
        },
        transition: {
          exit: false,
        },
      }}
    >
      {message}
      {warningList?.map((warning, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Box alignItems="flex-start" display="flex" key={`${warning}-${i}`} mb={1} mt={1}>
          <Avatar
            sx={{
              backgroundColor: 'error.light',
              height: 24,
              mr: 1.5,
              mt: 0.25,
              width: 24,
            }}
          >
            <PriorityHighRoundedIcon sx={{ color: 'error.dark', fontSize: 16 }} />
          </Avatar>
          <Typography fontWeight={600} variant="body2">
            {warning}
          </Typography>
        </Box>
      ))}
    </MDialog>
  );
};

export default GlobalConfirmationDialog;
